import { CalendarModuleCommandBarProps } from './commandBarItems/schema';
import { observer } from 'mobx-react-lite';
import { logUsage } from 'owa-analytics';
import { getNumDaysInDayRange } from 'owa-calendar-surface-options-utils';
import { surfaceStore } from 'owa-calendar-surface-surface-store';
import { Timestrip } from 'owa-timestrip';
import * as React from 'react';

const styles = require('./SurfaceTimestrip.scss');

export default observer(function SurfaceTimestrip(props: CalendarModuleCommandBarProps) {
    return (
        <Timestrip
            applySelectionStyling={true}
            className={styles.time}
            dateRange={surfaceStore.dateRange}
            dateRangeType={surfaceStore.dateRangeType}
            weekStartDay={surfaceStore.userOptions.weekStartDay}
            showWeekNumbers={surfaceStore.userOptions.showWeekNumbers}
            firstWeekOfYear={surfaceStore.userOptions.firstWeekOfYear}
            workDays={surfaceStore.userOptions.workDays}
            numDaysInDayRange={getNumDaysInDayRange()}
            useWeekDay={false}
            onDateRangeChange={props.onDateRangeChange}
            onDayPickerDateSelected={onDayPickerDateSelected}
            aria-setsize={props['aria-setsize']}
            aria-posinset={props['aria-posinset']}
        />
    );
});

function onDayPickerDateSelected(): void {
    logUsage('SurfaceTimestripCalSelectDate');
}
